import { paginateByPage } from 'src/feathers/hooks';

export default (app) => {
  const service = app.service('api/job-comments');
  service.name = 'jobComments';

  service.hooks({
    before: {
      all: [],
      find: [paginateByPage],
      get: [],
      create: [],
      update: [],
      patch: [],
      remove: []
    },

    after: {
      all: [],
      find: [],
      get: [],
      create: [],
      update: [],
      patch: [],
      remove: []
    },

    error: {
      all: [],
      find: [],
      get: [],
      create: [],
      update: [],
      patch: [],
      remove: []
    }
  });
};
